var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    [
      _c(
        "v-main",
        [
          _c(
            "v-container",
            { staticClass: "fill-height pa-4", attrs: { fluid: "" } },
            [
              _c(
                "v-row",
                {
                  attrs: {
                    justify: "center",
                    align: "center",
                    "no-gutters": "",
                  },
                },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "cb-col",
                      attrs: { cols: "12", sm: "8", md: "5", lg: "4" },
                    },
                    [
                      _c(
                        "v-card",
                        { attrs: { rounded: "lg", elevation: "3" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "text-center px-6 pt-8 pb-6",
                              style: _vm.headerStyle,
                            },
                            [
                              _c(
                                "v-avatar",
                                {
                                  staticClass: "mb-4",
                                  style: _vm.avatarStyle,
                                  attrs: { size: "96" },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: _vm.color, size: "52" } },
                                    [_vm._v(_vm._s(_vm.config.icon))]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "h1",
                                {
                                  staticClass: "text-h5 font-weight-bold mb-1",
                                },
                                [_vm._v(_vm._s(_vm.config.headline))]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-body-2 text--secondary mb-0",
                                },
                                [_vm._v(_vm._s(_vm.config.sub))]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "v-card-text",
                            { staticClass: "px-6 py-5" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-center justify-space-between mb-4",
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-overline text--secondary",
                                    },
                                    [_vm._v("Status")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-chip",
                                    {
                                      staticClass: "font-weight-bold",
                                      attrs: {
                                        color: _vm.color,
                                        small: "",
                                        label: "",
                                        outlined: "",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.config.statusLabel) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "text-overline text--secondary",
                                },
                                [_vm._v("Reference No.")]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-sheet",
                                {
                                  staticClass:
                                    "d-flex align-center justify-space-between px-3 py-2 mt-1",
                                  style: _vm.panelStyle,
                                  attrs: { rounded: "" },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "cb-ref text-subtitle-1 font-weight-bold",
                                    },
                                    [_vm._v(_vm._s(_vm.ref || "—"))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: _vm.color,
                                        small: "",
                                        outlined: "",
                                        disabled: !_vm.ref,
                                      },
                                      on: { click: _vm.copyRef },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { left: "", small: "" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.copied
                                                ? "mdi-check"
                                                : "mdi-content-copy"
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.copied ? "Copied" : "Copy"
                                          ) +
                                          "\n                "
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-divider", { staticClass: "my-4" }),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-caption text--secondary mb-0",
                                },
                                [_vm._v(_vm._s(_vm.config.note))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }